"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var react_1 = require("react");
var UserAgentContext_1 = require("@zapier/responsive-utils/dist/UserAgentContext");
var findMatchingQueries_1 = __importDefault(require("./findMatchingQueries"));
var guessUserAgentInfo_1 = __importDefault(require("./guessUserAgentInfo"));
var mergeProps = function (propsArray) {
    // `reverse` because this is `defaultsDeep`, so earlier
    // items in the array take precedence, but we want later
    // items to take precedence.
    return lodash_1.defaultsDeep.apply(void 0, __spread([{}], propsArray.reverse()));
};
var computeInitialPropsFromUserAgent = function (userAgent, mediaQueriesToProps) {
    var userAgentInfo = guessUserAgentInfo_1.default(userAgent);
    var mediaQueries = Object.keys(mediaQueriesToProps);
    var matchingQueries = findMatchingQueries_1.default(userAgentInfo, mediaQueries);
    var matchingProps = mediaQueries
        .filter(function (query) { return matchingQueries[query]; })
        .map(function (query) { return mediaQueriesToProps[query]; });
    return mergeProps(matchingProps);
};
var mergeMatchingProps = function (queryObjs) {
    var matchingProps = queryObjs
        .filter(function (queryObj) { var _a; return (_a = queryObj === null || queryObj === void 0 ? void 0 : queryObj.mediaQueryList) === null || _a === void 0 ? void 0 : _a.matches; })
        .map(function (queryObj) { return queryObj.props; });
    return mergeProps(matchingProps);
};
// Hook that takes a `mediaQueriesToProps` which is an object whose
// keys are media queries and whose values are objects
// representing props of one or more components. Returns
// a deeply merged object of all props matching the media
// queries defined in `mediaQueriesToProps`.
var useMediaProps = function (mediaQueriesToProps) {
    var userAgent = react_1.useContext(UserAgentContext_1.UserAgentContext);
    var initialProps = computeInitialPropsFromUserAgent(userAgent, mediaQueriesToProps);
    var _a = __read(react_1.useState(initialProps), 2), props = _a[0], setProps = _a[1];
    react_1.useEffect(function () {
        var mediaQueries = Object.keys(mediaQueriesToProps);
        // Hold onto `query`, `mediaQueryList`, and `props` since `matchMedia`
        // may change how `query` is structured and we need a way
        // to easily reaccess the `props` defined for that query.
        var queryObjs = mediaQueries.map(function (query) {
            return {
                query: query,
                mediaQueryList: window === null || window === void 0 ? void 0 : window.matchMedia(query),
                props: mediaQueriesToProps[query],
            };
        });
        // Merge all the props for matching media queries together
        // and then set them as the new props.
        var computeProps = function () {
            var newProps = mergeMatchingProps(queryObjs);
            // Perf enhancement / infinite loop prevention.
            if (!lodash_1.isEqual(newProps, props)) {
                setProps(newProps);
            }
        };
        // Listen to changes for each of the media queries.
        // These events only fire when a media query matches,
        // unlike `onresize`.
        queryObjs.forEach(function (queryObj) {
            var _a;
            if ((_a = queryObj === null || queryObj === void 0 ? void 0 : queryObj.mediaQueryList) === null || _a === void 0 ? void 0 : _a.addListener) {
                queryObj.mediaQueryList.addListener(computeProps);
            }
        });
        // Initial call to compute the props. Without this
        // the props would never be computed unless the user
        // resized their browser to match a media query.
        computeProps();
        // Return the teardown function.
        return function () {
            queryObjs.forEach(function (queryObj) {
                var _a;
                if ((_a = queryObj === null || queryObj === void 0 ? void 0 : queryObj.mediaQueryList) === null || _a === void 0 ? void 0 : _a.removeListener) {
                    queryObj.mediaQueryList.removeListener(computeProps);
                }
            });
        };
    }, [mediaQueriesToProps, props]);
    return props;
};
exports.default = useMediaProps;
